import Seo from "@/components/Seo";
import SiteNav from "@/components/SiteNav";
import KineticHero from "@/components/KineticHero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import DirectoryPreview from "@/components/DirectoryPreview";
import MembershipTiers from "@/components/MembershipTiers";
import TrustStandards from "@/components/TrustStandards";
import ComplianceFooter from "@/components/ComplianceFooter";

export default function Landing() {
  return (
    <div className="bg-obsidian min-h-screen">
      <Seo
        title="Monroe Society — The Private Companionship Directory"
        siteName="Monroe Society"
        description="An elevated, 18+ advertising platform connecting discerning adults with independent, verified companions for dinner, travel, and social engagements."
      />
      <SiteNav />
      <KineticHero />
      <EditorialMarquee />
      <Manifesto />
      <DirectoryPreview />
      <MembershipTiers />
      <TrustStandards />
      <ComplianceFooter />
    </div>
  );
}
